import createDefaultState from './state'

export const reset = (state) => {
  Object.assign(state, createDefaultState())
}

export const addToast = (state, options) => {
  Object.assign(state, { timeout: 4000, ...options, active: true })
}
